import React from 'react'
import Layout from '../../components/common/pageLayout'
import CreateForm from '../../components/FinalDrawing/createForm'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { toast } from 'react-toastify'
import { v3_edit_drawing } from '../../actions/v3/drawing'

const Index = (props) => {
    const location = useLocation();
    const { projectId, projectName, drawingData } = location.state || {};

    if (!drawingData) {
        return (
            <Layout title='Edit Drawing'>
                <div className="alert alert-warning mb-0">
                    Drawing details are missing. Please open edit from the drawing list.
                </div>
            </Layout>
        );
    }

    const onSubmit = (model) => {
        v3_edit_drawing({ ...model, id: drawingData?.ID }).then((res) => {
            if (res.status) {
                toast.success(res.result.message)

                props.history.push({
                    pathname: constant.Authedcomponent.finalDrawingDetail.url,
                    state: {
                        projectId,
                        projectName
                    }
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }

    return (
        <Layout title={`Edit Drawing | ${projectName || ''}`}>
            <CreateForm
                projectName={projectName}
                onSubmit={onSubmit}
                projectId={projectId}
                data={drawingData}
            />
        </Layout>
    )
}

export default Index
